import Raven from 'frontend/utils/raven';
import { Module } from 'vuex';

import { ResponseState, RootState } from 'frontend/types';

const response: Module<ResponseState, RootState> = {
  namespaced: true,
  state: () => ({
    base_url: undefined,
    debug: undefined,
    message: undefined,
    request_path: undefined,
    status: undefined,
    success: undefined,
  }),
  mutations: {
    setValue(state, value: ResponseState): void {
      Object.assign(state, value);
    },
  },
  getters: {
    baseUrl(state): string | undefined {
      return state.base_url;
    },
    debug(state: ResponseState): boolean {
      return Boolean(state.debug);
    },
    requestPath(state): string | undefined {
      return state.request_path;
    },
  },
};

export default response;
